var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var SnapSet = require("./../../snap/snapSet.js");
var SnapLineType = require("./../../snap/snapLineType.js");

var LineHandleModel = function (data, index, interactionModel) {
    var self = this;

    this.makeObservableTreeNode();

    this.modelData = data;
    this.interactionModel = interactionModel;

    this.pos = this.value("pos", true);
    this.selected = this.value("selected", true);
    this.highlighted = this.value("highlighted", true);
    this.activeFlag = this.value("activeFlag", true);

    // mouse coord is center if line is already placed, otherwise it is previous center
    this.centerMode = false;

    // constrain lines to 45 degree angles
    this.shiftMode = false;

    this.handleIndex = index;

    self.selectionModel = null;
    if(self.interactionModel && self.interactionModel.editorModel && self.interactionModel.editorModel.selectionModel) {
        self.selectionModel = self.interactionModel.editorModel.selectionModel();
    }

    // ---------------------------------------
    // change handlers for handle data changes
    // ---------------------------------------
    self.selected.onChange("selected_infocus", function (value) {
        if (self.parent().isAlive()) {
            self.parent().infocus(value);
            self.updateAllHandles();
        }
    }, 10);
    self.pos.onChange("interaction_model_coupling", function () {
        if (null == self.pos()) return;
        if (!self.interactionModel.noUpdateModel()) {
            self.updateModel();
        }
    }, 10);

    // ---------------------------------------
    // change handlers for data model changes
    // ---------------------------------------
    self.modelData.x1.onChange("interaction_model_coupling_reverse1", function () {
        if (self.isAlive() && self.parent().isAlive()) {
            self.updateAllHandles();
        }
    }, 10);
    self.modelData.x2.onChange("interaction_model_coupling_reverse2", function () {
        if (self.isAlive() && self.parent().isAlive()) {
            self.updateAllHandles();
        }
    }, 10);
    self.modelData.y1.onChange("interaction_model_coupling_reverse3", function () {
        if (self.isAlive() && self.parent().isAlive()) {
            self.updateAllHandles();
        }
    }, 10);
    self.modelData.y2.onChange("interaction_model_coupling_reverse4", function () {
        if (self.isAlive() && self.parent().isAlive()) {
            self.updateAllHandles();
        }
    }, 10);
};
lib_core.mixin(LineHandleModel, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(LineHandleModel, "LineHandleModel");

module.exports = LineHandleModel;

LineHandleModel.prototype.remove = function () {
};

LineHandleModel.prototype.updateAllHandles = function () {
    this.interactionModel.updateAllHandles();
};

/**
 * if center mode, need to adjust opposite coord
 * @param oldPos
 * @param newCoord
 */
LineHandleModel.prototype.checkCenterMode = function(oldPos, newCoord) {
    if (this.centerMode) {
        // set the other point mirrored across center point
        var vec = oldPos.sub(newCoord);
        newCoord = oldPos.add(vec);
        if (this.handleIndex == 1) {
            this.modelData.x2(newCoord.getX());
            this.modelData.y2(newCoord.getY());
        } else {
            this.modelData.x1(newCoord.getX());
            this.modelData.y1(newCoord.getY());
        }
        vec = null; // cleanup
    }
};

/**
 * update the model based on new handle information
 * @author Ed Pataky
 * @function updateModel
 */
LineHandleModel.prototype.updateModel = function () {
    var self = this;
    if (self.interactionModel.noUpdateModel()) return;

    self.interactionModel.noUpdateHandle(true);
    var oldPos = self.interactionModel.sessionCoord();
    var newCoord = new lib_geometry.Coord(self.pos().getX(), self.pos().getY());

    if (self.handleIndex == 1) {

        self.modelData.x1(newCoord.getX());
        self.modelData.y1(newCoord.getY());
        self.checkCenterMode(oldPos, newCoord);

    } else if (self.handleIndex == 2) {

        var changeVec = self.pos().sub(self.interactionModel.pos());
        self.modelData.x1(self.modelData.x1() + changeVec.getX());
        self.modelData.x2(self.modelData.x2() + changeVec.getX());
        self.modelData.y1(self.modelData.y1() + changeVec.getY());
        self.modelData.y2(self.modelData.y2() + changeVec.getY());

    } else {

        self.modelData.x2(newCoord.getX());
        self.modelData.y2(newCoord.getY());
        self.checkCenterMode(oldPos, newCoord);

    }
    oldPos = newCoord = null; // cleanup
    self.interactionModel.noUpdateHandle(false);
    self.updateAllHandles();
    self = null; // cleanup
};

/**
 * update the handle based on new model information
 * @author Ed Pataky
 * @function updateHandle
 * @param {boolean} update - should we update?
 */
LineHandleModel.prototype.updateHandle = function (update) {
    var self = this;

    if (this.interactionModel.noUpdateHandle()) return;

    if (update == undefined) update = true;

    if (update) {
        var newCoord = null;
        var hi = self.handleIndex;
        if (hi == 1) {
            newCoord = new lib_geometry.Coord(self.modelData.x1(), self.modelData.y1());
        } else if (hi == 2) {
            newCoord = this.interactionModel.pos();
        } else {
            newCoord = new lib_geometry.Coord(self.modelData.x2(), self.modelData.y2());
        }

        if (!(self.pos() && newCoord.eq(self.pos()))) {
            self.pos(newCoord);
        }

        hi = null;
        newCoord = null; // cleanup
    }

    self = null;
};

LineHandleModel.prototype.updateHandleNoModel = function () {
    this.interactionModel.noUpdateModel(true);
    this.updateHandle(true);
    this.interactionModel.noUpdateModel(false);
};

LineHandleModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

LineHandleModel.prototype.getInspectorElements = function () {
    return this.parent().getInspectorElements();
};

LineHandleModel.prototype.getSnapSet = function (type) {
    var snapSet = new SnapSet();
    if (!this.pos()) return snapSet;

    if(this.interactionModel && this.interactionModel.getSnapFilter) {
        snapSet.setFilter(this.interactionModel.getSnapFilter());
    }

    switch (type) {
        case SnapLineType.TO:
            snapSet.addHor(this.pos(), 1, 0, null, this.parent(), 0, "handle");
            snapSet.addVer(this.pos(), 1, 0, null, this.parent(), 0, "handle");
            break;
        case SnapLineType.FROM:
            snapSet.add(this.pos(), 1, 0, null, this.parent(), 0, "handle");
            break;
    }

    return snapSet;
};

/**
 * move the handle position, if shitmode, process here based on snapCoord45
 * before sending new coords
 * @param vec
 * @param keys
 */
LineHandleModel.prototype.move = function (vec, keys) {

    this.centerMode = keys.altKey;
    this.shiftMode = keys.shiftKey;

    if(!this.highlighted()) {
        return;
    }

    // if this is being moved, after being drawn, then absVec will have been set
    // via onElementMovingStart ... this adjustment makes sure the vector is correct with
    // respect to the current coord position ... (due to rounding/other errors the handle
    // and mouse position may not be equal without this adjustment - take my word for it)
    if(this.absVec && this.highlighted()) {
        this.absVec = this.absVec.add(vec);

        // where do we want it?
        var target = this.origCoord.add(this.absVec);

        // what should the vector be?
        vec = target.sub(this.pos());
    }

    //console.log("vec="+vec+", absVec="+this.absVec);

    var newCoord = this.pos().add(vec);

    if(this.shiftMode && this.handleIndex != 2) {

        var oldCenterPos = this.interactionModel.sessionCoord();

        var oppositeCoord = new lib_geometry.Coord(
            (this.handleIndex == 1 ? this.modelData.x2() : this.modelData.x1()),
            (this.handleIndex == 1 ? this.modelData.y2() : this.modelData.y1())
        );

        // what is the angle of this handle wrt the opposite coord?
        var checkVec = newCoord.sub((this.centerMode ? oldCenterPos : oppositeCoord));
        //console.log("newCoord="+newCoord+", "+checkVec.angleDegrees());
        var angle = checkVec.angleDegrees();
        angle = (angle+360)%360; // normalize

        // what is the nearest 45 degree angle?
        var snappedAngle = parseInt((angle+22.5) / 45, 10)*45;
        snappedAngle = (snappedAngle+360)%360; // normalize

        // should we snap it?
        var len = checkVec.length();
        var useCoord = (this.centerMode ? oldCenterPos : oppositeCoord);
        var delta = (new lib_geometry.Coord(len, 0)).rotate(snappedAngle);
        var snapCoord = useCoord.add(delta);
        //console.log("snap " + snapCoord + ", " + snappedAngle + " degrees");

        // snap it by angle
        this.pos(snapCoord);

        delta = useCoord = snapCoord = len = null;
        snappedAngle = oldCenterPos = angle = oppositeCoord = checkVec = null; // cleanup

    } else {
        this.pos(newCoord);
    }

    newCoord = null;
};

LineHandleModel.prototype.doubleClickAction = function () {
};

LineHandleModel.prototype.remove = function () {
};

LineHandleModel.prototype.onElementMovingStart = function() {
    this.origCoord = this.pos();
    this.absVec = new lib_geometry.Coord(0,0);
};
